import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import RouterWrapper from "../router-wrapper/component";

const Main = () => (
    <BrowserRouter>
        <Switch>
            <Route exact path='/:market/:lang/:option/:saleschannel' component={RouterWrapper}/>
            <Route exact path='/:market/:lang/:option' component={RouterWrapper}/>
            <Route exact path='/:market/:option' component={RouterWrapper}/>
            <Route component={RouterWrapper}/>
        </Switch>
    </BrowserRouter>
);

export default Main


// WEBPACK FOOTER //
// ./src/components/main/component.js